import { omit } from 'lodash'
import { FormikArraySchema, useClearOnUnmount, useFieldHelpers } from '@/base'
import { Multiselect, MultiselectProps } from '../multiselect'
import { FormField, FormFieldProps } from '.'

export const FormMultiselect = <T extends string>(
  props: Omit<MultiselectProps<T>, 'onChange' | 'value'> &
    Omit<FormFieldProps, 'children'> & {
      onChange?: (val: T[] | undefined) => void
      schema?: FormikArraySchema
      shouldClearOnDismount?: boolean
    }
) => {
  const {
    name,
    label,
    schema,
    message,
    description,
    optionalText,
    onChange,
    shouldClearOnDismount,
  } = props
  const { field, helpers } = useFieldHelpers({ name, schema })
  useClearOnUnmount(shouldClearOnDismount, helpers.setValue)

  return (
    <FormField
      name={name}
      label={label}
      schema={schema}
      message={message}
      description={description}
      optionalText={optionalText}
    >
      <Multiselect
        placeholder={(typeof label === 'string' && label) || undefined}
        {...omit(props, 'optionValues')}
        {...field}
        onBlur={() => helpers.setTouched(true)}
        onChange={(val: T[] | undefined) => {
          onChange?.(val)
          return helpers.setValue(val)
        }}
      />
    </FormField>
  )
}
